import React from "react";
import { Card, Button, Tag, Space, Typography, Statistic } from "antd";
import { PrinterOutlined, EnvironmentOutlined } from "@ant-design/icons";
import AddressLetter from "../../AddressLetter/index";
import { formatAddress } from "../../GuestDetails/utils";
import useUserLetterStatusQuery from "../../../api/queries/useUserLetterStatusQuery";
import useUserLetterPrinterMutation from "../../../api/mutations/useUserLetterPrinterMutation";
import { useQueryClient } from "@tanstack/react-query";
import PrintedWithButton from "./PrintedWithButton";

const { Text, Title } = Typography;

const AddresCard = ({ data }) => {
  const { data: letterStatus } = useUserLetterStatusQuery(data?.moveinInfo?.[0]?._id);
  const queryClient = useQueryClient();
  const { mutate, isPending } = useUserLetterPrinterMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["letter-status-user", data?.moveinInfo?.[0]?._id],
      });
    },
  });

  const moveInfo = data?.moveinInfo?.[0];

  const renderAddress = (type, addressData, isPrinted, printKey) => (
    <div style={{ marginBottom: 16 }}>
      <Space align="center" style={{ marginBottom: 8 }}>
        <EnvironmentOutlined style={{ fontSize: 16, color: "#0F1543" }} />
        <Title level={5} style={{ margin: 0 }}>{type} address</Title>
      </Space>
      <Text style={{ display: "block", marginBottom: 8 }}>
        {formatAddress(addressData)}
      </Text>
      {isPrinted ? (
        <PrintedWithButton
          onClick={async () => {
            await mutate({ [printKey]: false, moveinInfoId: moveInfo?._id });
          }}
        />
      ) : (
        <div
          onClick={async () => {
            await mutate({ [printKey]: true, moveinInfoId: moveInfo?._id });
          }}
        >
          <AddressLetter
            button={
              <Button icon={<PrinterOutlined />} disabled={isPending} type="primary" ghost>
                Print
              </Button>
            }
            address={formatAddress(addressData)}
            name={`${data?.firstName} ${data?.lastName} - ${type} Address`}
            extraProp1="value1"
            extraProp2="value2"
          />
        </div>
      )}
    </div>
  );

  return (
    <Card title="Moveinout Details" style={{ flex: 1 }}>
      {renderAddress("New", moveInfo?.newAddress, letterStatus?.isNewLetterPrinted, "isNewLetterPrinted")}
      {renderAddress("Old", moveInfo?.oldAddress, letterStatus?.isLetterPrinted, "isLetterPrinted")}
      <Statistic title="Total Companies" value={moveInfo?.companies?.length || 0} />
    </Card>
  );
};

export default AddresCard;
